<template>
    <v-container grid-list-xs>
        <div>
            <v-row>
                <v-col>
                    <v-sheet class="pa-5" elevation="3">
                        <div>
                            <h4 id="care_credit-decision-header" class="mb-4 text-h5 font-weight-bold primary--text">
                                {{ headerVerbiage }}
                            </h4>

                            <ul class="body-1 pl-3 mt-4 mb-8">
                                <li>
                                    {{ $t("results.existing.account.credit-line") }}:
                                    {{ creditLimitCents | currency }}
                                </li>
                                <li>
                                    {{ $t("results.existing.account.available-credit") }}:
                                    {{ availableAmountCents | currency }}
                                </li>
                                <li>
                                    {{ $t("results.existing.account.treatment-total") }}:
                                    {{ treatmentAmountCents | currency }}
                                </li>
                            </ul>

                            <p class="body-1 mb-2">
                                <strong>{{ $t("results.existing.account.whats-next") }}</strong>
                            </p>

                            <p id="care_credit-decision-body" class="body-1 grey--text text--darken-2 mb-10">
                                {{ messageVerbiage }}
                            </p>
                        </div>

                        <v-row align="center" justify="space-between" class="mt-12">
                            <v-col cols="auto" class="text-left">
                                <Button
                                    v-if="meetTheSale"
                                    outlined
                                    rounded
                                    class="secondary--text"
                                    @click="reviewAdditionalOptions"
                                >
                                    {{ $t("results.existing.account.review-additional-financing-options") }}
                                    <v-icon right color="secondary" class="right-arrow">$vuetify.icons.arrowRight</v-icon>
                                </Button>
                            </v-col>

                            <v-col cols="auto" class="text-right">
                                <Button class="secondary" rounded @click="next">
                                    {{ $t("action.got-it") }}
                                </Button>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
    import { mapState } from "vuex"
    import AutoFinishMixin from "@/components/apply/AutoFinishMixin"
    import { applicationState, sessionState } from "@/state"
    import ProviderKey from "@/model/provider/ProviderKey"
    import { applyService } from "@/service"
    import ApplyMode from "@/model/apply/ApplyMode"

    export default {
        mixins: [AutoFinishMixin],
        computed: {
            ...mapState("application", {
                treatmentAmountCents: state => state.data.purchaseAmountCents || 0,
            }),
            ...mapState("account", {
                availableAmountCents: state => state.data.availableAmountCents || 0,
                creditLimitCents: state => state.data.creditLimitCents || 0,
            }),
            meetTheSale() {
                // Meets the sale means available balance is within 500.00 of treatment amount
                return this.availableAmountCents + 50000 >= this.treatmentAmountCents
            },
            headerVerbiage() {
                return this.meetTheSale
                    ? this.$t("results.existing.account.header.mts", {
                          providerKey: ProviderKey.SYNCHRONY_STANDARD,
                      })
                    : this.$t("results.existing.account.header.does-not-mts", {
                          providerKey: ProviderKey.SYNCHRONY_STANDARD,
                      })
            },
            messageVerbiage() {
                return this.meetTheSale
                    ? this.$t("results.existing.account.message.mts", {
                          providerKey: ProviderKey.SYNCHRONY_STANDARD,
                      })
                    : this.$t("results.existing.account.message.does-not-mts", {
                          providerKey: ProviderKey.SYNCHRONY_STANDARD,
                      })
            },
        },
        methods: {
            async continueCascade() {
                applicationState.application.hasAgreedToCascade = true
                await applyService.patch(
                    sessionState.providerKey,
                    { application: applicationState.application, saveApplicationOnly: true },
                    ApplyMode.PREQUALIFY
                )
                await this.$router.push({
                    path: `/providers/${sessionState.nextProviderKeyAfterExistingAccount}/modes/${ApplyMode.PREQUALIFY}/switch`,
                })
            },

            async next() {
                if (this.meetTheSale) {
                    await this.$router.push({ path: `/providers/${sessionState.providerKey}/paymentPlans` })
                } else {
                    await this.continueCascade()
                }
            },
            async reviewAdditionalOptions() {
                await this.continueCascade()
            },
        },
    }
</script>
<style lang="scss" scoped>
    .right-arrow {
        border: 1.5px solid currentColor !important;
        border-radius: 50% !important;
        padding: 2px !important;
    }
</style>
